import { headerAndFooter as config } from '@config';
import { textWrapperTemplate, textAreaWrapperTemplate } from './page-heading.template';

export default class PageHeading {
  #layoutSectionId = null;
  #layoutSectionContainer = null;
  #pageHeadingElement = null;
  #isCurrentPage = null;

  #pageHeadingLevel;

  hasPageHeadingLevel (level) {
    return this.#pageHeadingLevel === level;
  }

  hasPageHeadingElement () {
    return !!this.#pageHeadingElement;
  }

  load (level, layoutSectionContainer, currentPage = false) {
    this.#isCurrentPage = currentPage;
    this.#pageHeadingLevel = level;
    this.#layoutSectionContainer = layoutSectionContainer;
    this.#pageHeadingElement = layoutSectionContainer?.querySelector(config.heading.attribute.selector);
  }

  updatePageHeading (content, headingAttributesGetter) {
    const headingElement = this.#isCurrentPage
      ? document.querySelector(config.heading.attribute.selector)
      : this.#layoutSectionContainer?.querySelector(config.heading.attribute.selector);

    const textElement = headingElement?.querySelectorAll('text');
    if (textElement && textElement.length) {
      textElement.forEach((text, index) => { index > 0 ? text.remove() : text.textContent = content; });
    } else {
      this.#createPageHeading(headingAttributesGetter());
    }

    INKIVE.EditorFacade.handle('header_and_footer', 'edit');
  }

  removePageHeading () {
    if (this.#pageHeadingElement) {
      this.#pageHeadingElement.parentElement.removeChild(this.#pageHeadingElement);
      this.#pageHeadingElement = null;
    }
  }

  getLayoutSectionId () {
    return this.#layoutSectionId;
  }

  setLayoutSectionId (id) {
    this.#layoutSectionId = id;
  }

  #createPageHeading ({ font, color, anchor, content }) {
    if (this.#isCurrentPage) {
      this.#createPageHeadingOnCurrentPage({ font, content });
      return;
    }

    const containerBox = this.#layoutSectionContainer.getBBox();

    const fontSize = config.heading.defaultFontSettings.size;
    const horizontalMargin = fontSize;
    const verticalMargin = (containerBox.height - fontSize) / 3;

    const headingId = this.#getNextPageHeadingId();
    const rectId = this.#getNextPageHeadingId(headingId);
    const position = { x: horizontalMargin, y: containerBox.y + verticalMargin };

    const textWrapper = document.createElementNS(svgedit.NS.SVG, 'g');
    textWrapper.innerHTML = textWrapperTemplate({
      color, font, fontSize, anchor, position, content
    });

    const size = {
      width: containerBox.width - horizontalMargin * 2,
      height: this.#getTextAreaHeightForTextNode(textWrapper)
    };

    const textAreaWrapper = document.createElementNS(svgedit.NS.SVG, 'g');
    textAreaWrapper.innerHTML = textAreaWrapperTemplate({
      headingId, rectId, position, size, textWrapper: textWrapper.innerHTML
    });

    this.#pageHeadingElement = textAreaWrapper.querySelector('g');
    this.#layoutSectionContainer.appendChild(this.#pageHeadingElement);
  }

  #createPageHeadingOnCurrentPage ({ font, content }) {
    const containerBox = this.#layoutSectionContainer.getBBox();
    const fontSize = config.heading.defaultFontSettings.size;
    const horizontalMargin = fontSize;
    const verticalMargin = (containerBox.height - fontSize) / 3;
    const position = { x: horizontalMargin, y: containerBox.y + verticalMargin };
    const size = {
      width: containerBox.width - horizontalMargin * 2
    };

    INKIVE.DesignFacade.create('text', {
      content,
      size,
      position,
      font: {
        ...font,
        size: config.heading.defaultFontSettings.size
      },
      meta: config.heading.attribute.value
    });
  }

  #getTextAreaHeightForTextNode (node) {
    const hasValidBox = document.body.contains(node);
    hasValidBox || document.querySelector(`#svgcontent > .${config.main.class}`).appendChild(node);
    const height = node.getBBox().height;
    hasValidBox || node.parentElement.removeChild(node);

    return height;
  }

  #getNextPageHeadingId (...alreadyTaken) {
    const idsInContainer = [...this.#layoutSectionContainer.querySelectorAll('[id]')].map(e => e.id);

    alreadyTaken = [...idsInContainer, ...alreadyTaken]
      .map(id => {
        const match = id.match(/svg_layout_(\d+)/);
        return match && parseInt(match[1]);
      })
      .filter(Boolean)
      .sort((a, b) => a > b ? -1 : 1);

    return `svg_layout_${alreadyTaken.length ? alreadyTaken[0] + 1 : 1}`;
  }
}
